/**
 * Tooltip - Desktop hover positioning and mobile modal
 */
document.addEventListener('DOMContentLoaded', () => {
    const isMobile = () => window.innerWidth <= 767;
    let modal = null;

    // Create mobile modal
    function createModal() {
        if (modal) return modal;

        modal = document.createElement('div');
        modal.className = 'c24-tooltip-modal-overlay';
        modal.innerHTML = `
            <div class="c24-tooltip-modal-dialog">
                <button class="c24-tooltip-modal-close" aria-label="Schließen">&times;</button>
                <div class="c24-tooltip-modal-content"></div>
            </div>
        `;
        document.body.appendChild(modal);

        modal.addEventListener('click', e => {
            if (e.target === modal || e.target.classList.contains('c24-tooltip-modal-close')) {
                closeModal();
            }
        });

        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
        });

        return modal;
    }

    function openModal(content) {
        const m = createModal();
        m.querySelector('.c24-tooltip-modal-content').innerHTML = content;
        m.classList.add('is-open');
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        if (modal) {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
        }
    }

    // Position tooltip using fixed positioning to avoid overflow clipping
    function positionTooltip(trigger, tooltip, wrapper) {
        tooltip.classList.remove('tooltip-align-left', 'tooltip-align-right', 'tooltip-position-top');
        tooltip.style.removeProperty('--arrow-left');
        tooltip.style.removeProperty('--arrow-right');

        // Use fixed positioning to escape overflow:hidden parents
        tooltip.style.position = 'fixed';
        tooltip.style.visibility = 'hidden';
        tooltip.style.display = 'block';

        const triggerRect = trigger.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        // Calculate position relative to viewport
        let top, left;
        const gap = 10;

        // Default is bottom; switch to top if not enough space below
        if (triggerRect.bottom + tooltipRect.height + gap > window.innerHeight) {
            tooltip.classList.add('tooltip-position-top');
            top = triggerRect.top - tooltipRect.height - gap;
        } else {
            top = triggerRect.bottom + gap;
        }

        // Horizontal positioning - try to center on trigger
        left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);

        // Check horizontal bounds
        if (left + tooltipRect.width > window.innerWidth - 20) {
            // Align to right edge
            tooltip.classList.add('tooltip-align-right');
            left = window.innerWidth - tooltipRect.width - 20;
            const arrowRight = window.innerWidth - triggerRect.left - (triggerRect.width / 2) - 20;
            tooltip.style.setProperty('--arrow-right', `${arrowRight}px`);
        } else if (left < 20) {
            // Align to left edge
            left = 20;
            const arrowLeft = triggerRect.left + (triggerRect.width / 2) - 20;
            tooltip.style.setProperty('--arrow-left', `${arrowLeft}px`);
        } else {
            // Centered - arrow at 50%
            tooltip.style.setProperty('--arrow-left', `${tooltipRect.width / 2}px`);
        }

        tooltip.style.top = `${top}px`;
        tooltip.style.left = `${left}px`;
        tooltip.style.bottom = 'auto';
        tooltip.style.transform = 'none';
        tooltip.style.visibility = 'visible';
    }

    // Setup tooltip behavior
    function setupTooltip(trigger, content, wrapper) {
        if (!trigger.hasAttribute('tabindex')) trigger.tabIndex = 0;
        let hideTimeout = null;

        function showTooltip() {
            if (hideTimeout) {
                clearTimeout(hideTimeout);
                hideTimeout = null;
            }
            if (!isMobile()) {
                positionTooltip(trigger, content, wrapper);
                content.style.display = 'block';
            }
        }

        function hideTooltip() {
            if (!isMobile()) {
                hideTimeout = setTimeout(() => {
                    content.style.display = 'none';
                    // Reset fixed positioning styles
                    content.style.position = '';
                    content.style.top = '';
                    content.style.left = '';
                    content.style.bottom = '';
                    content.style.transform = '';
                }, 100);
            }
        }

        trigger.addEventListener('click', e => {
            if (isMobile()) {
                e.preventDefault();
                e.stopPropagation();
                openModal(content.innerHTML);
            }
        });

        trigger.addEventListener('mouseenter', showTooltip);
        trigger.addEventListener('focus', showTooltip);
        trigger.addEventListener('mouseleave', hideTooltip);
        trigger.addEventListener('blur', hideTooltip);

        // Keep visible when hovering tooltip content
        content.addEventListener('mouseenter', showTooltip);
        content.addEventListener('mouseleave', hideTooltip);
    }

    // Initialize legacy tooltips
    document.querySelectorAll('.c24Tooltip.icon24Info').forEach(trigger => {
        let content = trigger.nextElementSibling;
        const wrapper = trigger.closest('.c24-tooltip-wrapper, .footmarker, .c24NoWrap, li, p, span, div');
        if (!content?.classList.contains('js24Tooltip')) {
            content = wrapper?.querySelector('.js24Tooltip');
        }
        if (content?.classList.contains('js24Tooltip') && wrapper) {
            setupTooltip(trigger, content, wrapper);
        }
    });

    // Initialize component tooltips
    document.querySelectorAll('.c24-tooltip-wrapper').forEach(wrapper => {
        const trigger = wrapper.querySelector(':scope > .c24-tooltip-trigger, :scope > .c24Tooltip');
        const content = wrapper.querySelector('.js24Tooltip, .c24-tooltip-content');
        if (content) {
            // If no trigger found, use wrapper itself as trigger
            setupTooltip(trigger || wrapper, content, wrapper);
        }
    });

    // Reset positioning on resize
    window.addEventListener('resize', () => {
        document.querySelectorAll('.js24Tooltip, .c24-tooltip-content').forEach(t => {
            t.classList.remove('tooltip-align-left', 'tooltip-align-right', 'tooltip-position-top');
            t.style.removeProperty('--arrow-left');
            t.style.removeProperty('--arrow-right');
            t.style.display = 'none';
            t.style.position = '';
            t.style.top = '';
            t.style.left = '';
            t.style.bottom = '';
            t.style.transform = '';
        });
    });
});
